/* ══════════════════════════════════════════════════════════════════
   47X · SUSCRIPCIÓN · destino limpio y confirmación que NO se repite

   1 · SIN VIAJE AL PIE. El {% form 'customer' %} de Shopify trae la
   acción /contact#contact_form. Al enviarlo, el navegador arrastra ese
   fragmento y aterrizas en /?customer_posted=true#contact_form: la URL
   queda anclada al formulario del pie y cada carga de esa pestaña se va
   sola hasta abajo (medido: de 0 a 7.412 px en un segundo). Aquí se le
   quita el fragmento a la acción antes de que nadie envíe nada.

   No se manda por fetch a propósito: /contact responde 400 · "Missing
   CAPTCHA token". El CAPTCHA invisible de Shopify solo se resuelve en
   el envío nativo.

   2 · LA CONFIRMACIÓN SE VE UNA VEZ. Antes el aviso salía en cada carga
   con ?customer_posted=true en la URL, así que reaparecía en cada
   refresh. Ahora: se muestra, se limpia ese parámetro del URL con
   replaceState (sin recargar) y se anota en el navegador que esta
   persona ya dejó su correo. A partir de ahí no vuelve a salir.

   Solo se guarda un booleano con su fecha. NUNCA el correo.
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__mail47) return;
  window.__mail47 = 1;

  var CLAVE = '47x_email_captured';
  var DIAS  = 90;

  function yaCapturado() {
    /* Shopify ya lo sabe: sesión de cliente con marketing aceptado */
    var raiz = document.documentElement;
    if (raiz && raiz.getAttribute('data-mail47-suscrito') === '1') return true;
    try {
      var v = localStorage.getItem(CLAVE);
      if (!v) return false;
      if (v === 'true') return true;                    /* valor viejo sin fecha */
      var t = parseInt(v, 10);
      if (!t) return false;
      return (Date.now() - t) < DIAS * 86400000;
    } catch (e) { return false; }
  }
  function marcaCapturado() {
    try { localStorage.setItem(CLAVE, String(Date.now())); } catch (e) {}
  }

  /* ── 1 · fuera el #contact_form de la acción ── */
  var forms = document.querySelectorAll('[data-mail47] form');
  for (var i = 0; i < forms.length; i++) {
    try {
      var a = forms[i].getAttribute('action') || '';
      if (a.indexOf('#') > -1) forms[i].setAttribute('action', a.split('#')[0]);
    } catch (e) {}
  }

  /* Si ya dejó su correo, el formulario del pie arranca en modo gracias:
     no tiene sentido volver a pedírselo en cada visita. */
  if (yaCapturado()) {
    var cajas = document.querySelectorAll('[data-mail47]');
    for (var c = 0; c < cajas.length; c++) cajas[c].classList.add('is-ok');
  }

  /* ── 2 · la confirmación ── */
  if (location.search.indexOf('customer_posted=true') === -1) return;

  /* Si el correo salió del POPUP, la confirmación la da el popup: se abre en
     modo éxito con el código y su CTA. Este aviso se aparta para que no haya
     dos confirmaciones a la vez. La marca de captado la pone igualmente el
     popup, así que la exclusión de 75 días vale para los dos caminos. */
  try { if (sessionStorage.getItem('pgx47:p1:enviado') === '1') return; } catch (e) {}

  /* Limpiar el URL SIEMPRE, se muestre o no el aviso: mientras
     customer_posted=true siga ahí, cualquier refresh lo reabriría. */
  var repentina = yaCapturado();
  marcaCapturado();
  limpiaURL();

  if (repentina) return;            /* ya lo vio en una visita anterior */

  var aviso = document.querySelector('[data-mail47-ok]');
  if (!aviso) return;
  aviso.removeAttribute('hidden');
  requestAnimationFrame(function () {
    requestAnimationFrame(function () { aviso.classList.add('is-ok'); });
  });

  var cerrar = function () {
    aviso.classList.remove('is-ok');
    setTimeout(function () { aviso.setAttribute('hidden', ''); }, 300);
  };
  var x = aviso.querySelector('[data-mail47-x]');
  if (x) x.addEventListener('click', cerrar, { once: true });
  setTimeout(cerrar, 6000);

  try { if (window.Ev47 && window.Ev47.pub) window.Ev47.pub('newsletter_signup', { origen: 'home_cierre' }); } catch (e) {}

  /* Quita customer_posted del URL conservando el resto de parámetros.
     replaceState: sin recarga, sin tocar el scroll, sin romper el back. */
  function limpiaURL() {
    try {
      var q = location.search.replace(/^\?/, '').split('&').filter(function (par) {
        return par && par.split('=')[0] !== 'customer_posted';
      });
      var nueva = location.pathname + (q.length ? '?' + q.join('&') : '') + location.hash;
      history.replaceState(history.state, '', nueva);
    } catch (e) {}
  }
})();
